// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile {
   width: 75vw;
   min-width: 300px;
   max-width: 800px;
   display: flex;
   flex-direction: column;
}

.user-profile header {
   display: flex;
   flex-direction: column;
   align-items: center;
}

.user-profile .avatar {
   height: 80px;
}

.user-profile .section-heading {
   display: flex;
   align-items: center;
}

.user-profile .separator-line {
   border-bottom: var(--border);
   flex: 1;
}

.user-profile .values-display,
.user-profile .message-sender-section {
   padding-left: var(--padding-lg);
}

.user-profile .value {
   display: flex;
   align-items: center;
}

.user-profile .value p {
   flex: 1;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLUserProfile/ECLUserProfile.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,gBAAgB;GAChB,gBAAgB;GAChB,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,mBAAmB;AACtB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,4BAA4B;GAC5B,OAAO;AACV;;AAEA;;GAEG,+BAA+B;AAClC;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,OAAO;GACP,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB","sourcesContent":[".user-profile {\r\n   width: 75vw;\r\n   min-width: 300px;\r\n   max-width: 800px;\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.user-profile header {\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n}\r\n\r\n.user-profile .avatar {\r\n   height: 80px;\r\n}\r\n\r\n.user-profile .section-heading {\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.user-profile .separator-line {\r\n   border-bottom: var(--border);\r\n   flex: 1;\r\n}\r\n\r\n.user-profile .values-display,\r\n.user-profile .message-sender-section {\r\n   padding-left: var(--padding-lg);\r\n}\r\n\r\n.user-profile .value {\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.user-profile .value p {\r\n   flex: 1;\r\n   overflow: hidden;\r\n   text-overflow: ellipsis;\r\n   white-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
